import { PermitteeType } from "~/enums/permitteeType";

export const TagColor = {
  [PermitteeType.originalSubmitter]: 'Orange',
  [PermitteeType.entityOwner]: 'Orange',
  [PermitteeType.allApprovers]: 'Purple',
  [PermitteeType.allCompleters]: 'Purple',
  [PermitteeType.stepCompleters]: 'Purple',
  [PermitteeType.group]: 'Blue',
  [PermitteeType.user]: 'Green',
  [PermitteeType.thirdParty]: 'Red',
  [PermitteeType.email]: 'Blue',
  [PermitteeType.objectOwner]: 'Orange',
  [PermitteeType.relatedObjectOwner]: 'Orange',
  [PermitteeType.anyone]: 'Blue',
  [PermitteeType.accountRelation]: 'Green',
  [PermitteeType.lookupField]: 'Orange',
  [PermitteeType.entityAccountRelation]: 'Green',
};